import { AppShell, Box, Center, Container, Loader } from '@mantine/core'
import { User } from '@ospace/auth'
import { userTypes } from '@ospace/core-auth'
import { Notifications } from '@mantine/notifications'
import { ReactElement } from 'react'

import { CustomHeader } from './CustomHeader'
import { Footer } from './Footer'
import classes from './FullPageLayout.module.css'

type Props =
  | {
      status: 'ready'
      children: ReactElement
      user: User
      role: userTypes
      title?: string
      subHeader?: ReactElement
      fluid?: boolean
    }
  | {
      status: 'loading'
      title?: string
      user?: User
      role: userTypes
      subHeader?: ReactElement
      fluid?: boolean
    }
  | {
      status: 'error'
      title?: string
      user?: User
      role: userTypes
      subHeader?: ReactElement
      fluid?: boolean
      message: string
    }

export const FullPageLayout = (props: Props) => {
  return (
    <>
      <Notifications />
      <AppShell className={classes.main}>
        <Box className={classes.mainContainer}>
          <CustomHeader
            user={props.user}
            role={props.role}
            subHeader={props.subHeader}
            pageTitle={props.title || ''}
          />
          <Container fluid={props.fluid} size={'1240'} py={'lg'}>
            {props.status === 'ready' ? props.children : null}
            {props.status === 'loading' ? (
              <Center
                style={{ minHeight: '100vh' }}
                h='100vh'
                mx='auto'
                role='alert'
                aria-label='loading'
              >
                <Loader variant='bars' role='alert' aria-label='loading' />
              </Center>
            ) : null}
            {props.status === 'error' ? props.message : null}
          </Container>
        </Box>
        <Footer />
      </AppShell>
    </>
  )
}
